export default __webpack_public_path__ + "static/media/brand.5a48a242.png";